import styles from './dashboard.module.scss';
import GithubDashboard from './components/GitHubDashboard';

type DashboardProps = {
  onSignOut: () => void;
};

export default function Dashboard({ onSignOut }: DashboardProps) {
  return (
    <div className={styles.dashboard}>
      <GithubDashboard onSignOut={onSignOut} />
    </div>
  );
}
